import React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

import { Button } from 'reactstrap';

const EditUserSubmitButton = ({ dispatch }) => (
    <Button
        className="mr2"
        color="primary"
        onClick={() => dispatch(submit('editUserForm'))}
    >
        Save
    </Button>
);

export default connect()(EditUserSubmitButton);



// WEBPACK FOOTER //
// ./src/components/Account/Edit/EditUserSubmitButton.js